import { getUpdateSchedulesFunction } from 'components/Templates/product/ProductEditTemplate'
import { Dispatch, SetStateAction, useCallback } from 'react'
import { ScheduleType } from 'types/schedule'
import { StockUnionType } from 'types/stock'

const useUnselectAllDaysOfWeek = (
  setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<ScheduleType[]>>
) => {
  return useCallback(
    (index: number, type: StockUnionType | '') => {
      const setState = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!setState) return
      setState((prevState) => {
        prevState[index].days_of_week = []
        return [...prevState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useUnselectAllDaysOfWeek
